import { z } from 'zod/v4';

import { ApiIntegrationStatusRuntype } from './3rdPartyBackendTypes';

export type AlfatecClientIdDTO = z.infer<typeof AlfatecClientIdDTORuntype>;
export const AlfatecClientIdDTORuntype = z.string();

export type AlfatecClientSecretDTO = z.infer<typeof AlfatecClientSecretDTORuntype>;
export const AlfatecClientSecretDTORuntype = z.string();

export type AlfatecCurrencyDTO = z.infer<typeof AlfatecCurrencyDTORuntype>;
export const AlfatecCurrencyDTORuntype = z.enum(['EUR', 'USD', 'CNY']);

export type AlfatecCustomerKeyDTO = z.infer<typeof AlfatecCustomerKeyDTORuntype>;
export const AlfatecCustomerKeyDTORuntype = z.string().nullable();

export interface AlfatecCredentialsDTO extends z.infer<typeof AlfatecCredentialsDTORuntype> {}
export const AlfatecCredentialsDTORuntype = z.object({
    client_id: AlfatecClientIdDTORuntype,
    client_secret: AlfatecClientSecretDTORuntype,
    currency: AlfatecCurrencyDTORuntype,
    customer_key: AlfatecCustomerKeyDTORuntype,
});

export interface AlfatecResponseBodyDTO extends z.infer<typeof AlfatecResponseBodyDTORuntype> {}
export const AlfatecResponseBodyDTORuntype = z.object({
    data: AlfatecCredentialsDTORuntype.nullable(),
    status: ApiIntegrationStatusRuntype,
});
